import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Save, Trash2 } from "lucide-react";
import api, { formatErr } from "../../lib/api";

export default function DevPages() {
  const [pages, setPages] = useState([]);
  const [active, setActive] = useState(null);
  const [creating, setCreating] = useState(false);
  const refresh = () => api.get("/developer/pages").then(r=>setPages(r.data));
  useEffect(()=>{ refresh(); }, []);

  const save = async () => {
    try {
      if (active.id) await api.put(`/developer/pages/${active.id}`, active);
      else await api.post("/developer/pages", active);
      toast.success("Saved"); setCreating(false); refresh();
    } catch (e) { toast.error(formatErr(e)); }
  };
  const del = async (id) => {
    if (!window.confirm("Delete page?")) return;
    await api.delete(`/developer/pages/${id}`); refresh(); setActive(null);
  };
  const addField = () => setActive({...active, form_fields: [...(active.form_fields||[]), { name: "", label: "", type: "text", required: false }]});
  const updField = (i, patch) => setActive({...active, form_fields: active.form_fields.map((f,idx)=>idx===i?{...f,...patch}:f)});
  const delField = (i) => setActive({...active, form_fields: active.form_fields.filter((_,idx)=>idx!==i)});

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div><div className="overline mb-2">CMS</div><h1 className="font-display text-4xl text-white">Custom Pages</h1></div>
        <button data-testid="page-new" onClick={()=>{setCreating(true); setActive({slug:"", title:"", body:"", form_fields:[], published:true});}} className="btn-primary"><Plus size={13}/> New Page</button>
      </div>
      <div className="grid md:grid-cols-[260px_1fr] gap-6">
        <div className="space-y-2">
          {pages.map(p => (
            <button key={p.id} onClick={()=>{setActive({...p}); setCreating(false);}} className={`w-full text-left card-luxe p-4 ${active?.id===p.id?"border-copper":""}`}>
              <div className="text-white text-sm">{p.title}</div>
              <div className="font-mono text-[10px] text-white/40 mt-1">/p/{p.slug}</div>
              <div className="text-[10px] mt-1">{p.published? <span className="text-[#32D74B]">● Published</span> : <span className="text-white/40">○ Draft</span>}</div>
            </button>
          ))}
          {pages.length === 0 && <div className="text-white/40 text-sm py-6 text-center">No pages yet</div>}
        </div>
        {active && (
          <div className="card-luxe p-6 space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div><div className="overline mb-1">Slug</div><input data-testid="page-slug" className="input-box" value={active.slug} onChange={(e)=>setActive({...active, slug:e.target.value})}/></div>
              <div><div className="overline mb-1">Title</div><input data-testid="page-title" className="input-box" value={active.title} onChange={(e)=>setActive({...active, title:e.target.value})}/></div>
            </div>
            <div><div className="overline mb-1">Body</div><textarea data-testid="page-body" rows={8} className="input-box resize-none" value={active.body} onChange={(e)=>setActive({...active, body:e.target.value})}/></div>
            <label className="flex items-center gap-2 text-sm text-white/80"><input type="checkbox" checked={!!active.published} onChange={(e)=>setActive({...active, published:e.target.checked})}/> Published</label>
            <div className="border-t border-white/5 pt-4">
              <div className="flex justify-between items-center mb-3"><div className="overline">Form Builder (optional)</div><button onClick={addField} className="btn-ghost text-xs"><Plus size={12}/> Field</button></div>
              <div className="space-y-2">
                {(active.form_fields||[]).map((f,i)=>(
                  <div key={i} className="grid grid-cols-12 gap-2 items-center">
                    <input className="input-box col-span-3 text-xs" placeholder="name" value={f.name} onChange={(e)=>updField(i,{name:e.target.value})}/>
                    <input className="input-box col-span-3 text-xs" placeholder="Label" value={f.label} onChange={(e)=>updField(i,{label:e.target.value})}/>
                    <select className="input-box col-span-3 text-xs" value={f.type} onChange={(e)=>updField(i,{type:e.target.value})}>
                      <option value="text">Text</option><option value="email">Email</option><option value="tel">Phone</option><option value="textarea">Textarea</option><option value="number">Number</option>
                    </select>
                    <label className="col-span-2 text-xs text-white/60 flex items-center gap-1"><input type="checkbox" checked={f.required} onChange={(e)=>updField(i,{required:e.target.checked})}/>Required</label>
                    <button onClick={()=>delField(i)} className="btn-ghost text-red-400 col-span-1"><Trash2 size={12}/></button>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex gap-3 border-t border-white/5 pt-4">
              <button data-testid="page-save" onClick={save} className="btn-primary"><Save size={13}/> Save</button>
              {active.id && <button onClick={()=>del(active.id)} className="btn-outline text-red-400 border-red-400/30"><Trash2 size={13}/> Delete</button>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
